import * as signalR from '@microsoft/signalr';
import { useAuthStore } from '@/store/auth';
import type { LiveSnapshot } from '@/api/endpoints';

// Helper para conectar/desconectar do hub SignalR de Live Players.
// Token JWT vai por query string ?access_token=... (browser nao pode setar Authorization
// header no handshake WebSocket).

const API_BASE_URL =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ||
  (import.meta.env.PROD ? 'https://api.codeshield.dev.br' : '/api');

export type SnapshotHandler = (snapshot: LiveSnapshot) => void;

export class LiveHubConnection {
  private connection: signalR.HubConnection | null = null;
  private onSnapshot: SnapshotHandler | null = null;

  async start(onSnapshot: SnapshotHandler): Promise<void> {
    this.onSnapshot = onSnapshot;
    if (this.connection && this.connection.state === signalR.HubConnectionState.Connected) return;

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${API_BASE_URL}/hubs/live-players`, {
        accessTokenFactory: () => useAuthStore.getState().accessToken || ''
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .configureLogging(signalR.LogLevel.Warning)
      .build();

    this.connection.on('snapshot', (snap: LiveSnapshot) => {
      this.onSnapshot?.(snap);
    });

    await this.connection.start();
  }

  async stop(): Promise<void> {
    try { await this.connection?.stop(); } catch { /* ok */ }
    this.connection = null;
    this.onSnapshot = null;
  }

  get state(): signalR.HubConnectionState | 'Disconnected' {
    return this.connection?.state ?? 'Disconnected';
  }
}
